export default "__VITE_ASSET__Dr1xl3AD__"